import { render, staticRenderFns } from "./OverviewMenu.vue?vue&type=template&id=558150c8"
import script from "./OverviewMenu.vue?vue&type=script&lang=ts"
export * from "./OverviewMenu.vue?vue&type=script&lang=ts"
import style0 from "./OverviewMenu.vue?vue&type=style&index=0&id=558150c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports